module.exports = __webpack_public_path__ + "static/media/VHST04.a1ac4f9d.jpg";